function getAdjustedWidthHeight(width, height, aspectRatio) {
    let adjustedWidth = width;
    let adjustedHeight = height;

    if (aspectRatio !== undefined) {
        if (!!width && !!height) {
            if (Math.ceil(width / height) !== Math.ceil(aspectRatio)) {
                adjustedHeight = null;
            }
        }

        if (!adjustedWidth) {
            adjustedWidth = height * aspectRatio;
        }

        if (!adjustedHeight) {
            adjustedHeight = width * (1 / aspectRatio);
        }
    }

    return { adjustedWidth, adjustedHeight };
}

function imageDimensionPropType(props, propName, componentName) {
    const {
        height,
        width,
        aspectRatio,
    } = props;

    const dimensionRequiredMessage = `${propName} must be a number`;

    if (!aspectRatio) {
        if (!props[propName] || typeof props[propName] !== 'number') {
            return new Error(
                `Required prop \`${propName}\` not supplied to \`${componentName}\`. ${dimensionRequiredMessage}`,
            );
        }
    } else {
        if (typeof height !== 'number' && typeof width !== 'number') {
            const missingPropType = typeof props[propName];
            return new Error(
                `Invalid prop \`${propName}\` of type \`${missingPropType}\` supplied to \`${componentName}\`.
                Height and width cannot both be undefined.`,
            );
        }

        if (typeof height === 'number' && typeof width === 'number') {
            if (Math.ceil(width / height) !== Math.ceil(aspectRatio)) {
                console.warn('Supplied width and height does not match the supplied aspect ratio.');
            }
        }
    }
}

export {
    getAdjustedWidthHeight,
    imageDimensionPropType,
};
